import { withStyles } from '@/components/Buttons/Core/withStyles';
import { BaseButton } from '@/components/Buttons/Core/BaseButton';

export const WarningButton = withStyles(BaseButton, {
    light: 'orange.500',
    dark: 'orange.700',
    textStyle: {
        light: 'white',
        dark: 'white'
    }
});